import { useMemo } from 'react';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { useAccessToken } from 'src/hooks/useAccessToken';
import { FetchError } from 'src/types/TApiQueries';
import { UploadLink } from 'src/types/TUploadLink';
import { closeUploadLink } from '../functions/uploadLinksApi';
import { queryFnFetchErrorWrapper } from '../utils/errorHandlers';
import { queryNames } from '../utils/queryNames';

// Done: closes the link. It answers with the link, which replaces the cached one.
export function useCloseUploadLinkMutation(
  linkId: string,
  mutationOptions?: UseMutationOptions<UploadLink, FetchError, void>,
) {
  const accessToken = useAccessToken();
  const queryClient = useQueryClient();

  const mutationFn = useMemo(
    () => queryFnFetchErrorWrapper(() => closeUploadLink(linkId, accessToken)),
    [linkId, accessToken],
  );

  return useMutation<UploadLink, FetchError, void>(mutationFn as any, {
    ...mutationOptions,
    onSuccess: (link, ...args) => {
      queryClient.setQueryData([queryNames.uploadLink, linkId], link);
      mutationOptions?.onSuccess?.(link, ...args);
    },
  });
}
